import { useState, useEffect, useCallback, useRef } from 'react'
import * as React from 'react'
import { v4 as uuidv4 } from 'uuid'
import '../styles/app.css'
import '../styles/messages.css'
import { useInitialMessages } from '../Hooks/initialMessages'
import Header from '../Components/Layout/Header'
import Textarea from '../Components/UI/TextArea'
import { MessageHandler } from '../Strategies/messageHandler'
import { MessageRenderer } from '../Strategies/messageRenderer'

const Chatbot = ({ onCloseChat }) => {
  const { botConfig } = useInitialMessages()
  const [messages, setMessages] = useState([])
  const [component, setComponent] = useState(null)
  const messagesEndRef = useRef(null)

  useEffect(() => {
    if (botConfig?.initialMessages) {
      setMessages(botConfig.initialMessages.map(msg => ({
        ...msg,
        id: uuidv4(),
        type: msg.type || 'bot',
        text: msg.text || 'Mensagem padrão',
      })))
    }
  }, [botConfig])

  const scrollToLatestMessage = useCallback(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, [])

  const sendMessage = useCallback((message) => {
    setMessages(prev => [...prev, message])
    setTimeout(scrollToLatestMessage, 100)
  }, [scrollToLatestMessage])

  const handleUserInput = useCallback((userMessage) => {
    if (!userMessage.trim()) return

    const userMessageObj = { text: userMessage, type: 'user', id: uuidv4() }
    setMessages(prev => [...prev, userMessageObj])
    setTimeout(scrollToLatestMessage, 100)

    const messageHandler = new MessageHandler(sendMessage, setComponent)
    messageHandler.handle(userMessage)
  }, [sendMessage, scrollToLatestMessage])

  return (
    <div className="chatbot">
      <Header onCloseChat={onCloseChat} />
      <div className="container-messages">
        <div className="inner-container">
          <MessageRenderer messages={messages} messagesEndRef={messagesEndRef} />
        </div>
        {component && React.createElement(component.name, { payload: component.payload })}
      </div>
      <Textarea onSend={handleUserInput} />
    </div>
  )
}

export default Chatbot